import api from "../instance/axios_instance.ts";
import {StatusInterface} from "../interface/statusInterface.ts";

const StatusApi = async (data: StatusInterface): Promise<StatusInterface> => {
    try {
        const response = await api.put<StatusInterface>('/update_status', data);
        return response.data;
    } catch (error: any) {
        const mensajeError = error.response?.data?.detail || "Error al actualizar el estado";
        throw new Error(mensajeError);
    }
};


export default StatusApi;
